import AssetIndexView from './view/AssetIndexView'
import AssetFilters from './components/filters/AssetFilters'
import ActivitiesTable from './components/table/ActivitiesTable'
import {
  TYPE_STATUS_ASSET_ACTIVITIES,
  LABEL_TO_STATUS_VALUE,
  FILTER_KEYS
} from './constants/assetActivitiesStatus'

const processAssetActivitiesForFilter = (filtersfetch, { TYPE_STATUS, LABEL_TO_STATUS_VALUE, FILTER_KEYS }) => {
  let mapping = {}
  const userOptions = (filtersfetch.user_asset_activities || []).map(u => {
    const label = `${u.user_uid} - ${u.user_full_name}`
    mapping[label] = u.user_uid
    return label
  })
  const clientOptions = (filtersfetch.clients_asset_activities || []).map(c => {
    const label = `${c.client_uid} - ${c.client_name}`
    mapping[label] = c.client_uid
    return label
  })
  TYPE_STATUS.forEach(label => { mapping[label] = LABEL_TO_STATUS_VALUE[label] })

  return {
    filters: [
      { key: FILTER_KEYS.USER, value: userOptions },
      { key: FILTER_KEYS.CLIENT, value: clientOptions },
      { key: FILTER_KEYS.STATUS, value: TYPE_STATUS }
    ],
    mapping
  }
}

export default function ActivitiesIndexView() {
  return (
    <AssetIndexView
      title="Reporte de activos"
      endpoint="asset_activities"
      FiltersComponent={AssetFilters}
      TableComponent={ActivitiesTable}
      showModelPath="/reporte_activos/"
      navActiveItem="Activos"
      processFiltersFn={processAssetActivitiesForFilter}
      statusConstants={{
        TYPE_STATUS: TYPE_STATUS_ASSET_ACTIVITIES,
        LABEL_TO_STATUS_VALUE,
        FILTER_KEYS
      }}
      searchPlaceholder="Buscar por # de documento o nombre de cliente" 
    />
  )
}
